var MercurialStatus = {
  ACTIVE: 0,
  INACTIVE: 1,
};

module.exports = MercurialStatus;
